{
  "pageTitle": "الأخبار والفعاليات",
  "title1": "أخبار وفعاليات",
  "title2": "المدرسة",
  "subtitle": "تابع أحدث الأخبار والفعاليات والإنجازات في مدرسة منارة",
  "allCategories": "الكل",
  "loadMore": "أظهر المزيد",
  "postsError": "فشل في الحصول على الأخبار"
}
